/*
 * @Author: qiong
 * @LastEditTime: 2021-09-23 09:40:44
 */
import request from 'utils/request';
import config from 'config/Config';
import { hex_md5, Encrypts } from 'utils/md5';
import { decryptParams } from 'utils/constants';

export default class {
  // 获取名片详情
  static getCardInfo(params) {
    return request({
      host: config.HOST_PROMOTE,
      url: 'userCard/detail/get',
      params,
      ignoreErr: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/BusinessCard/indexServ.js